import { defineStore } from 'pinia'
import { journalsApi } from '../api/journalsApi'
import { useErrorHandler } from '../composables/useErrorHandler'
import type { JournalAttribute, JournalItem } from '../types/journal.types'

export const useJournalDetailStore = defineStore('journalDetail', {
  state: () => ({
    selectedJournalId: null as number | null,
    currentJournal: null as JournalItem | null,
    isFetchingJournal: false,
    journalError: null as unknown | null,

    journalAttributes: [] as JournalAttribute[],
    isFetchingAttributes: false,
    attributesError: null as unknown | null,
  }),

  getters: {
    hasJournal(state): boolean {
      return state.currentJournal !== null
    },
  },

  actions: {
    async fetchJournal(journalId: number): Promise<void> {
      this.isFetchingJournal = true
      this.journalError = null

      const { handleError } = useErrorHandler()

      try {
        const data = await journalsApi.getJournal(journalId)

        this.currentJournal = data
        this.selectedJournalId = journalId
        this.journalAttributes = data.template_attributes || []
      } catch (e) {
        this.journalError = e
        handleError(e, 'Ошибка загрузки журнала')
      } finally {
        this.isFetchingJournal = false
      }
    },

    clearJournalData() {
      this.selectedJournalId = null
      this.currentJournal = null
      this.journalAttributes = []
    },
  },
})
